/* eslint-disable */
import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { restoreFocusOnDismissModal } from 'src/app/utils/overlay-controller.utils';
import { AddLoopHelpPage } from '../add-loop-help/add-loop-help.page';
import { AddStopsTutorialPage } from '../add-stops-tutorial/add-stops-tutorial.page';
import { StopDefinitionPage } from '../stop-definition/stop-definition.page';

@Component({
  selector: 'app-add-stops-help',
  templateUrl: './add-stops-help.page.html',
  styleUrls: ['./add-stops-help.page.scss']
})
export class AddStopsHelpPage implements OnInit {
  constructor(private modalCtrl: ModalController) {}

  async presentModal(page) {
    const pageMap = { stopDefinition: StopDefinitionPage, instructions: AddStopsTutorialPage, loop: AddLoopHelpPage };
    const modal = await this.modalCtrl.create({ component: pageMap[page], cssClass: 'modal-responsive' });
    await modal.present();
    restoreFocusOnDismissModal(modal);
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }

  ngOnInit() {}
}
